// Maps a BDC KYC `PEPHistory.Motive` code to a pt-BR label. Codes and meanings come from the BDC
// docs (pessoas-kyc-e-compliance), except `PEP PARTNER`: it shows up in the data but isn't
// documented, and is read as the documented `PEERS` (business partner of a PEP).

export const PEP_MOTIVE_LABELS: Record<string, string> = {
  'FEDERAL EMPLOYEE': 'Servidor federal',
  'STATE EMPLOYEE': 'Servidor estadual',
  'CITY EMPLOYEE': 'Servidor municipal',
  'OWNERSHIP AT PUBLIC SECTOR': 'Sócio de empresa no setor público',
  OTHER: 'OUTRO',
  BROTHER: 'IRMÃO(A)',
  MOTHER: 'MÃE',
  SON: 'FILHO(A)',
  PEERS: 'SÓCIO(A)',
  'PEP PARTNER': 'SÓCIO(A)',
  FATHER: 'PAI',
  GRANDPARENT: 'AVÔ',
  SPOUSE: 'CÔNJUGE',
  GRANDSON: 'NETO(A)',
};

// Unknown codes keep the source value, so a new BDC code still shows up instead of a blank cell.
export function getPepMotiveLabel(motive: string | null): string | null {
  if (!motive) return null;
  return PEP_MOTIVE_LABELS[motive.trim().toUpperCase()] ?? motive;
}
